const PREFIX = "COMPANY"
const COMPANY_TYPES = {
  CREATE: `${PREFIX}/CREATE`,
  UPDATE: `${PREFIX}/UPDATE`,
  GET_BY_ID: `${PREFIX}/GET_BY_ID`,
  CLEAR: `${PREFIX}/CLEAR`
}

export default COMPANY_TYPES
